import { withProps } from 'recompose';
import Input from './Input';

const Text = withProps({
    type: 'text',
})(Input);

export default Text;
